/////////////////////
// EndpointsConfig //
/////////////////////

const API_BASE_URL = process.env.REACT_APP_API_URI || '';

export interface EndpointsConfig {
  threads: (page: string) => string;
  chat: (page: string) => string;
  messages: (page: string) => string;
  feedback: (page: string) => string;
  filters: (page: string) => string;
  docTree: (page: string) => string;
  upload: string;
  docprocessbar: (userId: string) => string;
  /** Jobs Legal persistés (Elasticsearch) — liste / suppression */
  legalJobs: (userId: string) => string;
  /** Derniers chemins documents d’un fil Legal (pré-sélection UI) */
  legalJobSelection: (userId: string, threadId: string) => string;
  /** Reprise SSE sur une recherche exhaustive déjà en cours (endpoint unique, tous les modes) */
  exhaustiveSearchResume: () => string;
  /** Annulation explicite d'une recherche exhaustive en cours (arrêt job serveur). */
  exhaustiveSearchCancel: () => string;
  /** Dev : relance uniquement la synthèse finale (macro) sans refaire le carrousel doc-à-doc. */
  exhaustiveSearchResynthesizeFinal: () => string;
  /** Santé des index ES chunks (Market, MyDeal, Oreima, Legal) — page d'accueil */
  chunksHealth: () => string;
  legalJobDelete: (userId: string, taskId: string) => string;
  summarize: string;
  showSummary: string;
  hasSummary: string;
  delete: string;
  // getProcessingFiles: string;
}

export const endpointsCf: EndpointsConfig = {
  threads: (page: string) => `${API_BASE_URL}/${page}/session_manager/thread_ids`,
  chat: (page: string) => `${API_BASE_URL}/${page}/chat`,
  messages: (page: string) => `${API_BASE_URL}/${page}/session_manager/thread_history`,
  feedback: (page: string) => `${API_BASE_URL}/${page}/session_manager/feedback_update`,
  filters: (page: string) => `${API_BASE_URL}/${page}/filters`,
  docTree: (page: string) => `${API_BASE_URL}/${page}/doc_tree`,
  upload: `${API_BASE_URL}/upload`,
  docprocessbar: (userId: string) => `${API_BASE_URL}/docprocessbar/${userId}`,
  legalJobs: (userId: string) => `${API_BASE_URL}/legal/legal_jobs/${userId}`,
  legalJobSelection: (userId: string, threadId: string) =>
    `${API_BASE_URL}/legal/legal_jobs/selection/${userId}/${encodeURIComponent(threadId)}`,
  legalJobDelete: (userId: string, taskId: string) =>
    `${API_BASE_URL}/legal/legal_jobs/${userId}/${encodeURIComponent(taskId)}`,
  exhaustiveSearchResume: () =>
    `${API_BASE_URL}/chat/exhaustive-search/resume`,
  exhaustiveSearchCancel: () =>
    `${API_BASE_URL}/chat/exhaustive-search/cancel`,
  exhaustiveSearchResynthesizeFinal: () =>
    `${API_BASE_URL}/chat/exhaustive-search/resynthesize-final`,
  chunksHealth: () => `${API_BASE_URL}/health/chunks`,
  summarize: `${API_BASE_URL}/summarize`,
  showSummary: `${API_BASE_URL}/show_summary`,
  hasSummary: `${API_BASE_URL}/has_summary`,
  delete: `${API_BASE_URL}/delete`,
  // getProcessingFiles: `${API_BASE_URL}/get_processing_files`,
};

//////////////////
// PagesContent //
//////////////////

//TextboxContent

interface Container {
  key: string;
  title: string;
  tooltip: string;
  modeValue: string;
  icon: string;
  label: string;
}

interface PageContent {
  pageTitle: string;
  containers: Container[];
}

interface PagesContent {
  [key: string]: PageContent;
}

export const pagesContent: PagesContent = {
  market: {
    pageTitle: "Market Intelligence",
    containers: [
      {
        key: "SEARCH",
        title: "Internal Search",
        tooltip: "Search in documents from Infravia database.",
        modeValue: "SEARCH",
        icon: "bi bi-database",
        label: "Database Search"
      },
      {
        key: "CHATGPT",
        title: "Azure Chat",
        tooltip: "Format Georges' answers (emails, synthesis...) or translate them",
        modeValue: "CHAT",
        icon: "bi bi-chat",
        label: "ChatGPT"
      },
      {
        key: "PERPLEXITY",
        title: "External Search",
        tooltip: "Go on Perplexity to search the web",
        modeValue: "PERPLEXITY",
        icon: "https://scienzai.com/wp-content/uploads/2023/12/Perplexity-Logo.png",
        label: "Perplexity"
      },
      {
        key: "MYGEORGES",
        title: "MyGeorges",
        tooltip: "Upload a document and chat with it.",
        modeValue: "MYGEORGES",
        icon: "bi bi-folder",
        label: "My Georges"
      },
      {
        key: "AI",
        title: "Georges chooses",
        tooltip: "Have a fluid conversation and let Georges decide if you ask a question (Database Search) or if you want to chat (ChatGPT)",
        modeValue: "UNDEFINED",
        icon: "bi bi-robot",
        label: "AI decides your mode"
      }
    ]
  },
  legal: {
    pageTitle: "Legal Assistant",
    containers: [
      {
        key: "SEARCH",
        title: "Database Search",
        tooltip: "Search in documents from Infravia database.",
        modeValue: "SEARCH",
        icon: "bi bi-database",
        label: "Database Search"
      },
      {
        key: "CHATGPT",
        title: "Discussion",
        tooltip: "Format Georges' answers (emails, synthesis...) or translate them",
        modeValue: "CHAT",
        icon: "bi bi-chat",
        label: "Discussion"
      },
      {
        key: "PERPLEXITY",
        title: "External Search",
        tooltip: "Go on Perplexity to search the web",
        modeValue: "PERPLEXITY",
        icon: "https://scienzai.com/wp-content/uploads/2023/12/Perplexity-Logo.png",
        label: "Perplexity"
      },
      {
        key: "AI",
        title: "Georges chooses",
        tooltip: "Let Georges decide if you need a database search or a chat for your question",
        modeValue: "UNDEFINED",
        icon: "bi bi-robot",
        label: "AI decides your mode"
      }
    ]
  },
  mydeal: {
    pageTitle: "My Deal Analysis",
    containers: [
      {
        key: "SEARCH",
        title: "Database Search",
        tooltip: "Search in documents from Infravia database.",
        modeValue: "SEARCH",
        icon: "bi bi-database",
        label: "Database Search"
      },
      {
        key: "CHATGPT",
        title: "ChatGPT",
        tooltip: "Format Georges' answers (emails, synthesis...) or translate them",
        modeValue: "CHAT",
        icon: "bi bi-chat",
        label: "ChatGPT"
      },
      {
        key: "PERPLEXITY",
        title: "External Search",
        tooltip: "Go on Perplexity to search the web",
        modeValue: "PERPLEXITY",
        icon: "https://scienzai.com/wp-content/uploads/2023/12/Perplexity-Logo.png",
        label: "Perplexity"
      },
      {
        key: "MYGEORGES",
        title: "MyGeorges",
        tooltip: "Upload a document and chat with it.",
        modeValue: "MYGEORGES",
        icon: "bi bi-folder",
        label: "My Georges"
      },
      {
        key: "AI",
        title: "Georges chooses",
        tooltip: "Have a fluid conversation and let Georges decide if you ask a question (Database Search) or if you want to chat (ChatGPT)",
        modeValue: "UNDEFINED",
        icon: "bi bi-robot",
        label: "AI decides your mode"
      }
    ]
  },
  oreima: {
    pageTitle: "Market Intelligence",
    containers: [
      {
        key: "SEARCH",
        title: "Internal Search",
        tooltip: "Search in documents from Infravia database.",
        modeValue: "SEARCH",
        icon: "bi bi-database",
        label: "Database Search"
      },
      {
        key: "CHATGPT",
        title: "Azure Chat",
        tooltip: "Format Georges' answers (emails, synthesis...) or translate them",
        modeValue: "CHAT",
        icon: "bi bi-chat",
        label: "ChatGPT"
      },
      {
        key: "PERPLEXITY",
        title: "External Search",
        tooltip: "Go on Perplexity to search the web",
        modeValue: "PERPLEXITY",
        icon: "https://scienzai.com/wp-content/uploads/2023/12/Perplexity-Logo.png",
        label: "Perplexity"
      },
      {
        key: "MYGEORGES",
        title: "MyGeorges",
        tooltip: "Upload a document and chat with it.",
        modeValue: "MYGEORGES",
        icon: "bi bi-folder",
        label: "My Georges"
      },
      {
        key: "AI",
        title: "Georges chooses",
        tooltip: "Have a fluid conversation and let Georges decide if you ask a question (Database Search) or if you want to chat (ChatGPT)",
        modeValue: "UNDEFINED",
        icon: "bi bi-robot",
        label: "AI decides your mode"
      }
    ]
  },
};

//////////////////
// FiltersConfig //
//////////////////

interface FilterConfig {
  id: string;
  label: string;
  type: string;
  tooltip: string;
  default?: any;
}

export const LegalmainFilters: FilterConfig[] = [
  {
    "id": "dealName",
    "label": "Deal",
    "type": "multiselect",
    "tooltip": "Select one or more deals to filter. When multiple deals are chosen, a comparative table is automatically generated by Georges"
  },
  {
    "id": "docType",
    "label": "Document type",
    "type": "multiselect",
    "tooltip": "Filter by document type categories such as SHA (Shareholder Agreements), SFA and CTA (Senior Facilities Agreements / Common Terms Agreement), SA (Sales Agreement), ICA (Intercreditor Agreement), Hedging (ISDA, FBA)"
  },
  {
    "id": "docName",
    "label": "Document name",
    "type": "multiselect",
    "tooltip": "Filter by specific document names to narrow down your search within selected deals and document types"
  }
];

export const LegaldealFilters: FilterConfig[] = [
    {
      "id": "status",
      "label": "Status",
      "type": "multiselect",
      "default": [
        "Live"
      ],
      "tooltip": "Filter deals based on their current status"
    },
    {
      "id": "fund",
      "label": "Fund",
      "type": "multiselect",
      "tooltip": "Filter deals based on the fund associated to the deal"
    },
    {
      "id": "companySize",
      "label": "EBITDA",
      "type": "range",
      "tooltip": "Filter deals based on the size of the target company"
    },
    {
      "id": "sector",
      "label": "Sector",
      "type": "multiselect",
      "tooltip": "Select one or more sectors to filter deals based on the industry or business area of the company involved"
    },
    {
      "id": "location",
      "label": "Geography",
      "type": "multiselect",
      "tooltip": "Filter deals based on the country or region where the target is located"
    },
    {
      "id": "yearOfDeal",
      "label": "Year",
      "type": "range",
      "default": {
        "min": 2013,
        "max": 2024
      },
      "tooltip": "Select a range of years to filter deals based on when they were initiated or completed"
    },
    {
      "id": "shares",
      "label": "% of Shares held",
      "type": "range",
      "tooltip": "Filter deals based on the percentage of shares held"
    }
  ];

export const LegaldocFilters: FilterConfig[] = [
  {
    "id": "docStatus",
    "label": "Active/Inactive",
    "type": "multiselect",
    "default": [
      "Active"
    ],
    "tooltip": "Filter documents based on their current status"
  },
  {
    "id": "debt",
    "label": "Debt type",
    "type": "multiselect",
    "tooltip": "Select specific types of debt associated with the documents, if applicable"
  },
  {
    "id": "lender",
    "label": "Lender",
    "type": "multiselect",
    "tooltip": "Filter by lenders involved in the documentation, if any are specified"
  },
  {
    "id": "fundingSize",
    "label": "Amount",
    "type": "range",
    "tooltip": "Filter by the funding size or amount specified in the document"
  }
];


//////////////////
// ChatInputConfig //
//////////////////

export interface ChatInputConfig {
  optionIcons: {
    SEARCH: { icon: string; label: string };
    CHAT: { icon: string; label: string };
    PERPLEXITY: { icon: string; label: string };
    MYGEORGES: { icon: string; label: string };
    UNDEFINED: { icon: string; label: string };
  };
}

export const chatInputConfig: ChatInputConfig = {
  optionIcons: {
    "SEARCH": { icon: "bi bi-database", label: "Search Infravia" },
    "CHAT": { icon: "bi bi-chat", label: "Everyday chat" },
    "PERPLEXITY": { icon: "bi bi-globe", label: "Explore" },
    "MYGEORGES": { icon: "bi bi-folder", label: "Chat with my docs" },
    "UNDEFINED": { icon: "bi bi-binoculars", label: "Smart Search" },
  }
};

